webpackJsonp([0],{

/***/ "+jo3":
/***/ (function(module, exports) {

googleTranslateElementInit = function googleTranslateElementInit() {
  new google.translate.TranslateElement({ pageLanguage: 'en', includedLanguages: 'ar,de,en,es,fr,ht,pt,vi', layout: google.translate.TranslateElement.InlineLayout.SIMPLE }, 'google_translate_element');
};

// google translate
(function (i, s, o, g, a, m) {
  a = s.createElement(o), m = s.getElementsByTagName(o)[0];
  a.async = 1;
  a.src = g;
  m.parentNode.insertBefore(a, m);
})(window, document, 'script', 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit');

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "28QG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: {
      type: String,
      required: true
    }
  }
});

/***/ }),

/***/ "5vvv":
/***/ (function(module, exports) {

module.exports = [{"Children":[{"Guid":"1fd37855-fb65-455d-8a93-c2912c55951d","Name":"Animals and Pets","Description":"","Path":"https://www.hillsboroughcounty.org/en/residents/animals-and-pets"},{"Guid":"43be8a74-dcd2-43e3-a54e-0083538c0ee9","Name":"Citizens","Description":"","Path":"https://www.hillsboroughcounty.org/en/residents/citizens"},{"Guid":"b93f0add-c7b1-4dc2-a10c-eb66e2182a88","Name":"Families","Description":"","Path":"https://www.hillsboroughcounty.org/en/residents/families"},{"Guid":"a45d25e3-b329-4dcf-b9ad-9f97562b6cdc","Name":"Property Owners and Renters","Description":"","Path":"https://www.hillsboroughcounty.org/en/residents/property-owners-and-renters"},{"Guid":"01deb159-f6f2-4eab-9552-daef202413be","Name":"Public Safety","Description":"","Path":"https://www.hillsboroughcounty.org/en/residents/public-safety"},{"Guid":"a48af759-c81b-411f-9c3a-0f07d567c472","Name":"Recreation and Culture","Description":"","Path":"https://www.hillsboroughcounty.org/en/residents/recreation-and-culture"},{"Guid":"fdf63233-a6a3-4bab-9e79-959890d6e7bf","Name":"Social Services","Description":"","Path":"https://www.hillsboroughcounty.org/en/residents/social-services"},{"Guid":"22a19116-a3e4-49b0-bff9-03266133fda4","Name":"Stay Safe","Description":"","Path":"https://www.hillsboroughcounty.org/en/residents/stay-safe"},{"Guid":"c9866301-a227-4ac6-9d47-fd0c9caf6607","Name":"Sustainability and Green","Description":"","Path":"https://www.hillsboroughcounty.org/en/residents/sustainability-and-green"}],"Guid":"34cb3843-b435-4992-9957-6b68496e39a2","Name":"Residents","Description":"","Path":"https://www.hillsboroughcounty.org/en/residents","FeaturedLink":{"Excerpt":"Request services from Hillsborough County online 24 hours-a-day, 7 days-a-week...","Url":"https://service.hillsboroughcounty.org/311/","ImgSrc":"/library/hillsborough/system/logos/atyourservicelogo.png","Guid":"56d4f47f-ad19-4331-a31b-3aa8b1e72e3c","Name":"At Your Service","Description":"Request services from Hillsborough County online 24 hours-a-day, 7 days-a-week...","Path":"https://service.hillsboroughcounty.org/311/"}},{"Children":[{"Guid":"2bd1a9af-251a-4393-990d-2f8d0caa1c64","Name":"Business Community","Description":"","Path":"https://www.hillsboroughcounty.org/en/businesses/business-community"},{"Guid":"a21ec51b-dd21-4344-81bf-e2d91ffe99d3","Name":"Entrepreneur and Small Business Support","Description":"","Path":"https://www.hillsboroughcounty.org/en/businesses/entrepreneur-and-small-business-support"},{"Guid":"ae402569-6c4e-49a1-9dbb-d6f7db5185b1","Name":"Doing Business With Hillsborough","Description":"","Path":"https://www.hillsboroughcounty.org/en/businesses/doing-business-with-hillsborough"},{"Guid":"11c7076f-4350-412c-8889-7d7cd2e32f6a","Name":"Economic Development","Description":"","Path":"https://www.hillsboroughcounty.org/en/businesses/economic-development"},{"Guid":"d06c5a0c-afd9-4654-8f30-64304f02b17c","Name":"Land Development","Description":"","Path":"https://www.hillsboroughcounty.org/en/businesses/land-development"},{"Guid":"1759ebb5-a69f-4c1d-a68b-36bc5bfd2910","Name":"Permits and Records","Description":"","Path":"https://www.hillsboroughcounty.org/en/businesses/permits-and-records"},{"Guid":"cfd306e2-8546-4d50-baf5-8096f220be4b","Name":"Zoning","Description":"","Path":"https://www.hillsboroughcounty.org/en/businesses/zoning"}],"Guid":"c7e8e62a-0501-4df0-a0e6-ef275bf33665","Name":"Businesses","Description":"","Path":"https://www.hillsboroughcounty.org/en/businesses","FeaturedLink":{"Excerpt":"24/7 online development permitting solution","Url":"https://www.hillsboroughcounty.org/en/government/departments/development/hillsgovhub","ImgSrc":"/library/hillsborough/media-center/images/hillsgovhubmenu.png","Guid":"2453072d-5401-4ab4-8f91-cf90a3220e6d","Name":"HillsGovHub","Description":"24/7 online development permitting solution","Path":"https://www.hillsboroughcounty.org/en/government/departments/development/hillsgovhub"}},{"Children":[{"Guid":"26eef89c-4922-48e8-b207-4fc243292788","Name":"Agencies","Description":"","Path":"https://www.hillsboroughcounty.org/en/government/agencies"},{"Guid":"ef7c58e7-f9e1-424e-a706-75747fb77270","Name":"Board of County Commissioners","Description":"","Path":"https://www.hillsboroughcounty.org/en/government/board-of-county-commissioners"},{"Guid":"74e9e9b3-06fa-4a8a-9b16-9720cbe097a6","Name":"Boards and Committees","Description":"","Path":"https://www.hillsboroughcounty.org/en/government/boards-and-committees"},{"Guid":"65b48e45-ec0a-41ab-9604-735c7a3339d4","Name":"Budget","Description":"","Path":"https://www.hillsboroughcounty.org/en/government/budget"},{"Guid":"b791e2bd-e96d-400f-9351-a6832c1218ca","Name":"Codes and Ordinances","Description":"","Path":"https://www.hillsboroughcounty.org/en/government/codes-and-ordinances"},{"Guid":"e69ddbdc-640e-4bd9-831d-b82a83f1524f","Name":"County Projects","Description":"","Path":"https://www.hillsboroughcounty.org/en/government/county-projects"},{"Guid":"6d9cf152-1e5b-4a2f-833b-dcd23c166889","Name":"Departments","Description":"A list of all County departments with links to department information pages","Path":"https://www.hillsboroughcounty.org/en/government/departments"},{"Guid":"2cd849d4-3839-469c-84cf-8176bab28278","Name":"Grants","Description":"","Path":"https://www.hillsboroughcounty.org/en/government/grants"},{"Guid":"e47b54da-74b1-49f3-9b01-8c0f6cf61d33","Name":"Leadership","Description":"","Path":"https://www.hillsboroughcounty.org/en/government/leadership"},{"Guid":"35745b2a-e000-4829-a75d-006e972f9616","Name":"Meeting Information","Description":"","Path":"https://www.hillsboroughcounty.org/en/government/meeting-information"},{"Guid":"8a0bd604-aee9-43c7-b78c-3cb1a67ff6f9","Name":"Real Estate and Facility Services","Description":"","Path":"https://www.hillsboroughcounty.org/en/government/real-estate-and-facility-services"},{"Guid":"41dee0bc-2cd5-44d2-b783-0d6cee95f88d","Name":"Special Districts","Description":"","Path":"https://www.hillsboroughcounty.org/en/government/budget/special-districts"}],"Guid":"2075bb92-9176-4fbb-8bbe-68fb561e3d36","Name":"Government","Description":"","Path":"https://www.hillsboroughcounty.org/en/government","FeaturedLink":{"Excerpt":"Register to receive time-sensitive messages about emergencies and certain non-emergency events – straight from us to you.","Url":"https://www.hillsboroughcounty.org/en/residents/public-safety/emergency-management/hcfl-alert","ImgSrc":"/library/hillsborough/promotions/hcflalert.png","Guid":"985debd1-7105-4d41-892c-016b7532cc04","Name":"HCFL Alert","Description":"Register to receive time-sensitive messages about emergencies and certain non-emergency events – straight from us to you.","Path":"https://www.hillsboroughcounty.org/en/residents/public-safety/emergency-management/hcfl-alert"}},{"Children":[{"Guid":"76b8a45e-a99a-4b1f-a887-95a765368253","Name":"Calendar","Description":"","Path":"https://www.hillsboroughcounty.org/en/calendar"},{"Guid":"0bd28c64-c753-4efd-b5b0-dd47f87ad68d","Name":"Charter","Description":"","Path":"https://www.hillsboroughcounty.org/en/about-hillsborough/charter"},{"Guid":"6735c7b0-295c-4169-8fe2-42d60d96944b","Name":"Community Calendar","Description":"","Path":"https://www.hillsboroughcounty.org/en/residents/property-owners-and-renters/homeowners-and-neighborhoods/community-calendar"},{"Guid":"4844d3a4-ccdd-4833-ab31-9842240e6a27","Name":"Contact Us","Description":"","Path":"https://www.hillsboroughcounty.org/en/about-hillsborough/contact-us"},{"Guid":"c5c0e2c3-2b67-42f8-b6d7-bc780d6fb93f","Name":"Hillsborough Television","Description":"","Path":"https://www.hillsboroughcounty.org/en/about-hillsborough/hillsborough-television"},{"Guid":"e989cfdd-fa81-49b3-8e83-d4438d289073","Name":"History","Description":"","Path":"https://www.hillsboroughcounty.org/en/about-hillsborough/history"},{"Guid":"b527d0b1-fd74-4e03-ad83-feb1226b614e","Name":"Jobs","Description":"","Path":"https://www.hillsboroughcounty.org/en/about-hillsborough/jobs"},{"Guid":"056ba7db-f1d2-49b8-8003-01699ba8143f","Name":"Locations","Description":"","Path":"https://www.hillsboroughcounty.org/en/locations"},{"Guid":"d8772e0a-e276-4206-ad39-4b4e5b5712db","Name":"Open Data","Description":"","Path":"https://www.hillsboroughcounty.org/en/about-hillsborough/open-data"}],"Guid":"851d1661-67f5-4079-85e4-baea02ad7936","Name":"About Hillsborough","Description":"","Path":"https://www.hillsboroughcounty.org/en/about-hillsborough","FeaturedLink":{"Excerpt":"Information on COVID-19 vaccines, testing, as well as resources and case tracking.","Url":"","ImgSrc":"/library/hillsborough/media-center/images/covid19/covid-19-dashboard.png","Guid":"70d9b5c3-65a4-44f3-a640-4eedb19449ae","Name":"Dashboard","Description":"Information on COVID-19 vaccines, testing, as well as resources and case tracking.","Path":""}},{"Children":[{"Guid":"61c3af76-b8c3-4018-8500-4eef63c37314","Name":"Apply","Description":"Permits, Licenses...","Path":"https://www.hillsboroughcounty.org/en/i-want-to/apply"},{"Guid":"4057c0ee-1a04-486a-856e-ea2a676f0055","Name":"Register","Description":"Animals, Permits, Water...","Path":"https://www.hillsboroughcounty.org/en/i-want-to/register"},{"Guid":"106b0492-68c5-4958-a24b-e7efd0d0d30f","Name":"Report","Description":"Violations, Repairs, Animals...","Path":"https://www.hillsboroughcounty.org/en/i-want-to/report"},{"Guid":"203e93e7-552b-4cf9-bdc5-5e75a111684c","Name":"Request","Description":"Records, Services, Inspections...","Path":"https://www.hillsboroughcounty.org/en/i-want-to/request"},{"Guid":"fec93185-44a2-44b5-8a94-5dcb441178e0","Name":"Pay","Description":"Bills, Fees, Taxes...","Path":"https://www.hillsboroughcounty.org/en/i-want-to/pay"}],"Guid":"acce922f-9f4a-4ee1-abe5-7370ce8785f3","Name":"I Want To","Description":"","Path":"https://www.hillsboroughcounty.org/en/i-want-to","FeaturedLink":null}]

/***/ }),

/***/ "6XRP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_LinkTargets__ = __webpack_require__("ScBB");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_LinkTargets__["a" /* default */]],
  data: function data() {
    return {
      footerLinks: [{
        text: 'Board of County Commissioners',
        href: 'https://hillsboroughcounty.org/government/board-of-county-commissioners'
      }, {
        text: 'Contact Us',
        href: 'https://hillsboroughcounty.org/about-hillsborough/contact-us'
      }, {
        text: 'County Locations',
        href: 'https://hillsboroughcounty.org/residents/citizens/county-locations'
      }, {
        text: 'Jobs',
        href: 'https://hillsboroughcounty.org/about-hillsborough/jobs'
      }, {
        text: 'HCFL Alert Information',
        href: 'https://hillsboroughcounty.org/residents/public-safety/emergency-management/hcfl-alert'
      }, {
        text: 'Accessibility',
        href: 'https://hillsboroughcounty.org/government/departments/ada'
      }],
      socialLinks: [{
        name: 'Facebook',
        href: 'https://www.facebook.com/HillsboroughFL/',
        iconClass: 'fab fa-facebook'
      }, {
        name: 'Twitter',
        href: 'https://twitter.com/HillsboroughFL',
        iconClass: 'fab fa-twitter'
      }, {
        name: 'YouTube',
        href: 'https://www.youtube.com/user/HillsboroughCounty',
        iconClass: 'fab fa-youtube'
      }, {
        name: 'InstaGram',
        href: 'https://www.instagram.com/hillsboroughfl/',
        iconClass: 'fab fa-instagram'
      }, {
        name: 'LinkedIn',
        href: 'https://www.linkedin.com/company/hillsborough-county',
        iconClass: 'fab fa-linkedin'
      }],
      logoUrl: 'https://raw.githubusercontent.com/Commbocc/html-wrapper/master/src/assets/hc-logo-horizontal-RGB_drkbgrd.png'
    };
  }
});

/***/ }),

/***/ "DOgq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"bg-secondary text-white py-5",attrs:{"id":"hc-footer"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row align-items-center text-center"},[_c('div',{staticClass:"col-lg-6 col-md-12 mb-4 order-md-2"},[_c('ul',{staticClass:"list-inline mb-0"},_vm._l((_vm.footerLinks),function(link){return _c('li',{staticClass:"list-inline-item mx-3"},[_c('a',{staticClass:"text-white",attrs:{"href":link.href,"target":_vm.linkTargets}},[_vm._v("\n              "+_vm._s(link.text)+"\n            ")])])}),0)]),_vm._v(" "),_c('div',{staticClass:"col-lg-3 col-md-6 mb-4 order-lg-1 order-md-3"},[_c('a',{attrs:{"href":"https://hillsboroughcounty.org","target":_vm.linkTargets}},[_c('img',{staticClass:"logo img-fluid",attrs:{"src":_vm.logoUrl,"alt":"Hillsborough County Logo"}})])]),_vm._v(" "),_c('div',{staticClass:"col-lg-3 col-md-6 mb-4 order-md-12"},[_c('ul',{staticClass:"list-inline my-2 hide-external-indicator"},_vm._l((_vm.socialLinks),function(link){return _c('li',{staticClass:"list-inline-item"},[_c('a',{staticClass:"text-white",attrs:{"href":link.href,"title":link.name,"target":"_blank","aria-label":link.name}},[_c('span',{staticClass:"fa-fw",class:link.iconClass,attrs:{"aria-hidden":"true"}})])])}),0),_vm._v(" "),_c('div',{staticClass:"my-2",attrs:{"id":"google_translate_element"}}),_vm._v(" "),_c('a',{staticClass:"hide-external-indicator small text-white",attrs:{"href":"https://hcflgov.formstack.com/forms/website_feedback","target":"_blank"}},[_vm._v("\n          Provide Website Feedback\n        ")])])]),_vm._v(" "),_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text-center small mt-3 mb-0"},[_c('a',{staticClass:"text-white hide-external-indicator",attrs:{"href":"https://goo.gl/maps/jetXJdK71mu","target":"_blank"}},[_vm._v("\n        601 E. Kennedy Blvd."),_c('br'),_vm._v("\n        Tampa, FL 33602\n      ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "L9eR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HcFooter_vue__ = __webpack_require__("6XRP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b48fcf0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HcFooter_vue__ = __webpack_require__("DOgq");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HcFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b48fcf0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HcFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("W4fZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MipF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar navbar-expand-lg navbar-light bg-white",attrs:{"id":"hc-nav","aria-label":"Site Navigation"}},[_c('div',{staticClass:"container-fluid"},[_c('a',{staticClass:"sr-only",attrs:{"href":_vm.skipContentLink}},[_vm._v("Skip to Main Content")]),_vm._v(" "),_c('a',{staticClass:"navbar-brand",attrs:{"href":_vm.logoHref,"target":_vm.logoTarget}},[_c('img',{staticClass:"logo",attrs:{"src":_vm.logoUrl,"alt":"Hillsborough County Logo"}})]),_vm._v(" "),_c('button',{ref:"navToggler",staticClass:"navbar-toggler",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navbarSupportedContent","aria-controls":"navbarSupportedContent","aria-expanded":"false","aria-label":"Toggle navigation"}},[_c('span',{staticClass:"navbar-toggler-icon"})]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"navbarSupportedContent"}},[_c('ul',{staticClass:"navbar-nav ml-auto"},[(_vm.showForm)?_c('li',{staticClass:"nav-item order-lg-12 dropdown",attrs:{"id":"hc-nav-search-nav-item"}},[_c('a',{staticClass:"nav-link dropdown-toggle d-none d-lg-inline-block",attrs:{"href":"#","title":"Search","role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"},on:{"click":function($event){return _vm.focusSearch()}}},[_c('span',{staticClass:"fas fa-fw fa-search",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Search")])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu hc-nav-search-dropdown-menu"},[_c('NavSearchForm',{ref:"searchForm",attrs:{"action":_vm.formAction,"method":_vm.formMethod,"target":_vm.formTarget,"show-filters":"formShowFilters"}})],1)]):_vm._e(),_vm._v(" "),(_vm.customNav)?_vm._t("default"):_vm._l((_vm.navLinks),function(link){return _c('li',{staticClass:"nav-item order-lg-1 dropdown"},[_c('a',{staticClass:"nav-link dropdown-toggle",attrs:{"href":"#","role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v("\n            "+_vm._s(link.Name)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu"},[_c('h4',{staticClass:"d-none d-lg-block text-info font-serif font-weight-bold"},[_vm._v(_vm._s(link.Name))]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu-2-col"},_vm._l((link.Children),function(child){return _c('a',{staticClass:"dropdown-item",attrs:{"href":_vm.navbarUrl(child),"target":_vm.linkTargets}},[_vm._v("\n                "+_vm._s(child.Name)+"\n              ")])}),0)])])})],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__("8+8L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap__ = __webpack_require__("K3J8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_js_google_translate__ = __webpack_require__("+jo3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_js_google_translate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_js_google_translate__);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#hc-main',
  extends: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]
});

/***/ }),

/***/ "PyiM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HcBanner_vue__ = __webpack_require__("28QG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87d817a8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HcBanner_vue__ = __webpack_require__("mqr5");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HcBanner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87d817a8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HcBanner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ScBB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    linkTargets: {
      type: String,
      default: '_self'
    }
  }
});

/***/ }),

/***/ "W4fZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bBDc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{attrs:{"action":_vm.action,"method":_vm.method,"target":_vm.target}},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-lg-8"},[_c('hr',{staticClass:"mb-2 mb-lg-0 d-lg-none"}),_vm._v(" "),_c('div',{staticClass:"input-group input-group-lg",attrs:{"id":"hc-nav-search-input-group"}},[_c('input',{ref:"searchInput",staticClass:"form-control",attrs:{"name":"q","type":"search","placeholder":"Search For...","aria-label":"Search Input","required":""}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('hr',{staticClass:"mt-2 mt-lg-0 mb-0 mb-lg-2"})])]),_vm._v(" "),(_vm.showFilters)?_c('fieldset',{staticClass:"d-none d-lg-block"},[_c('legend',{staticClass:"sr-only"},[_vm._v("Filters")]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center"},_vm._l((_vm.filters),function(filter){return _c('div',{staticClass:"form-check form-check-inline small"},[_c('input',{staticClass:"form-check-input",attrs:{"type":"checkbox","name":"t","id":("search-filter-" + (filter.key)),"aria-label":filter.text},domProps:{"value":filter.key,"checked":filter.checked}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":("search-filter-" + (filter.key))}},[_c('span',{staticClass:"fa-fw",class:filter.icon,attrs:{"aria-hidden":"true"}}),_vm._v("\n          "+_vm._s(filter.text)+"\n        ")])])}),0)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-link",attrs:{"type":"submit"}},[_c('span',{staticClass:"fas fa-fw fa-search",attrs:{"aria-label":"Search"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eMYj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HcNavSearchForm_vue__ = __webpack_require__("mTMR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a5d0548_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HcNavSearchForm_vue__ = __webpack_require__("bBDc");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HcNavSearchForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a5d0548_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HcNavSearchForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "geF4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_navbar_json__ = __webpack_require__("5vvv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_navbar_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_navbar_json__);
// let navEnpoint = 'https://www.hillsboroughcounty.org/apis/v1/endpoints/navbar'


/* harmony default export */ __webpack_exports__["a"] = ({
  // props: {
  //   crossOrigin: {
  //     type: Boolean,
  //     default: true
  //   },
  //   crossOriginRoot: {
  //     type: String,
  //     default: 'https://hillsboroughcounty.org'
  //   }
  // },
  data: function data() {
    return {
      navLinks: []
    };
  },

  methods: {
    fetchNavbar: function fetchNavbar() {
      this.navLinks = __WEBPACK_IMPORTED_MODULE_0__assets_navbar_json___default.a;
    },
    navbarUrl: function navbarUrl(item) {
      return item.Path;
    }
  },
  mounted: function mounted() {
    this.fetchNavbar();
  }
});

/***/ }),

/***/ "mTMR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['action', 'method', 'target', 'showFilters'],
  data: function data() {
    return {
      filters: [{
        key: 'article',
        text: 'Web Pages',
        icon: ' far fa-file',
        checked: false
      }, {
        key: 'story',
        text: 'Newsroom Stories',
        icon: ' far fa-newspaper',
        checked: false
      }, {
        key: 'documents',
        text: 'Documents',
        icon: ' far fa-file-pdf',
        checked: false
      }, {
        key: 'events',
        text: 'Events',
        icon: ' far fa-calendar-alt',
        checked: false
      }, {
        key: 'locations',
        text: 'Locations',
        icon: ' fas fa-map-marker-alt',
        checked: false
      }, {
        key: 'departments',
        text: 'Departments',
        icon: ' far fa-building',
        checked: false
      }]
    };
  }
});

/***/ }),

/***/ "md8n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HcNavigation_vue__ = __webpack_require__("siLz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84bc01cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HcNavigation_vue__ = __webpack_require__("MipF");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HcNavigation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84bc01cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HcNavigation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mqr5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hc-banner jumbotron jumbotron-fluid bg-info text-white my-0 py-4"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"hc-banner-title font-weight-bold m-0"},[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")]),_vm._v(" "),_c('nav',{attrs:{"aria-label":"Breadcrumb Navigation"}},[_c('ol',{staticClass:"breadcrumb hc-banner-breadcrumb mb-0"},[_vm._t("default"),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active",attrs:{"aria-current":"page"}},[_vm._v(_vm._s(_vm.title))])],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "o3A7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_HcNavigation__ = __webpack_require__("md8n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HcBanner__ = __webpack_require__("PyiM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_HcFooter__ = __webpack_require__("L9eR");




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    HcNavigation: __WEBPACK_IMPORTED_MODULE_0__components_HcNavigation__["a" /* default */], HcBanner: __WEBPACK_IMPORTED_MODULE_1__components_HcBanner__["a" /* default */], HcFooter: __WEBPACK_IMPORTED_MODULE_2__components_HcFooter__["a" /* default */]
  }
});

/***/ }),

/***/ "siLz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HcNavSearchForm__ = __webpack_require__("eMYj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_NavLinks__ = __webpack_require__("geF4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_LinkTargets__ = __webpack_require__("ScBB");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_NavLinks__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_LinkTargets__["a" /* default */]],
  props: {
    logoHref: {
      type: String,
      default: 'https://hillsboroughcounty.org'
    },
    logoTarget: {
      type: String,
      default: '_self'
    },
    // search form props
    showForm: {
      type: Boolean,
      default: true
    },
    formAction: {
      type: String,
      default: 'https://hillsboroughcounty.org/search'
    },
    formMethod: {
      type: String,
      default: 'get'
    },
    formTarget: {
      type: String,
      default: '_self'
    },
    formShowFilters: {
      type: Boolean,
      default: true
    },
    customNav: {
      type: Boolean,
      default: false
    },
    skipContentLink: {
      type: String,
      default: '#main-content'
    }
  },
  components: { NavSearchForm: __WEBPACK_IMPORTED_MODULE_1__HcNavSearchForm__["a" /* default */] },
  data: function data() {
    return {
      logoUrl: 'https://github.com/Commbocc/html-wrapper/raw/master/src/assets/hc-logo-horizontal-RGB.png'
    };
  },

  methods: {
    focusSearch: function focusSearch() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].nextTick(function () {
        _this.$refs.searchForm.$refs.searchInput.focus();
      });
    }
  }
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_Components_js__ = __webpack_require__("o3A7");



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_Components_js__["a" /* default */]]
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.js